exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input {\n     text-align: right; \n     border: none;\n     width: 100%;\n     background: transparent;\n} \n\ninput:focus {\n    outline: none;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Grid/qtyEditor.component.css
// module id = 447
// module chunks = 1